/*
  CRAN. — "La composition" (Partie 2 §8)
  Fait basculer l'image active de la colonne média collée selon le
  chapitre actuellement au centre de l'écran. Dégradé garanti : la
  première image reste affichée (voir cran-pdp-gallery.liquid /
  .cran-pdp-gallery__image.is-active par défaut en CSS) tant que ce
  script n'a pas pu observer les chapitres — jamais de média manquant.
*/
(function () {
  if (!('IntersectionObserver' in window)) {
    return;
  }

  var galleries = document.querySelectorAll('.cran-pdp-gallery');
  if (!galleries.length) {
    return;
  }

  galleries.forEach(function (gallery) {
    var chapters = gallery.querySelectorAll('[data-gallery-chapter]');
    var images = gallery.querySelectorAll('[data-gallery-image]');
    if (!chapters.length || !images.length) {
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }
          var index = entry.target.getAttribute('data-gallery-chapter');
          images.forEach(function (img) {
            img.classList.toggle('is-active', img.getAttribute('data-gallery-image') === index);
          });
        });
      },
      { threshold: 0, rootMargin: '-45% 0px -45% 0px' }
    );

    chapters.forEach(function (chapter) {
      observer.observe(chapter);
    });
  });
})();
